module.exports = __webpack_public_path__ + "static/media/ron-blankstein.ca5d3efa.jpg";